import { createSelector } from 'reselect';
export const selectRentalHistory = createSelector(state => state.rentalHistory.data, state => state.entities.skinConfig, (data, skinConfig) => {
  return data.map(e => {
    if (!e) {
      return e;
    }

    const skinInfo = skinConfig === null || skinConfig === void 0 ? void 0 : skinConfig[e.skinId];
    return skinInfo ? { ...e,
      imageAvatar: skinInfo.imageAvatar,
      skinName: skinInfo.name
    } : e;
  });
});